import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Menu } from '@material-ui/icons';

import nakedNewsLogo from '../../assets/logo-naked-news.png';
import nudeNewsLogo from '../../assets/nudenews-logo.png';
import anchorPortalLogo from '../../assets/anchor-portal-logo.png';
import nakedNewsLogoWhite from '../../assets/Affiliate/Logos Icons/NN-logo.png';
import nakedNewsLiveLogo from '../../assets/NakedNewsLive/NNL_192x36.png';
import { isNakedNewsLiveDomain, isNudeDomain } from '../../utils/helpers';
import CountdownTimerComponent from '../generalComponents/CountdownTimerComponent/CountdownTimerComponent';
import { isGuestOrFreemiumUser } from '../../utils/getUserDetails';


const HeaderLogoAndDropDown = (props) => {
  const {
    activeCampaign,
    location,
    toggleMobileHeader,
    isAnchorPortal,
    user,
    userPremiumExpired,
  } = props;
  const logo = useMemo(() => {
    if (isAnchorPortal) {
      return anchorPortalLogo;
    }

    if (isNudeDomain) {
      return nudeNewsLogo;
    }

    if (isNakedNewsLiveDomain) {
      return nakedNewsLiveLogo;
    }

    if (location?.pathname === '/affiliates' || isGuestOrFreemiumUser(user)) {
      return nakedNewsLogoWhite;
    }

    return nakedNewsLogo;
  }, [isAnchorPortal, location?.pathname, user]);

  return (
    <div
      className={`navbar-header ${isAnchorPortal ? 'anchor-portal-topnav-header' : ''}`}
      id="navbar-header"
    >
      <button
        className={`${isAnchorPortal ? 'anchor-portal-topnav-toggle' : 'navbar-toggle navbar-toggle-custom'
        }`}
        type="button"
        onClick={toggleMobileHeader}
      >
        <span className="sr-only">Toggle navigation</span>
        <Menu fontSize="inherit" />
      </button>
      {(userPremiumExpired || (user && !user.authenticated)) &&
        activeCampaign &&
        activeCampaign.hasTimer &&
        activeCampaign.secondsLeft && (
        <div className="navbar-toggle navbar-toggle-custom navbar-toggle-custom-countdown">
          <CountdownTimerComponent activeCampaign={activeCampaign} />
        </div>
      )}
      <div className="hidden-xs">
        {isGuestOrFreemiumUser(user) && !isAnchorPortal && <div id="red-background" />}
        <Link className="navbar-brand" to={isAnchorPortal ? '/dashboard' : '/home'}>
          <img
            alt="Naked News: The Program With Nothing To Hide"
            className={`img-responsive ${isAnchorPortal ? 'anchor-portal-logo' : ''}`}
            src={logo}
          />
        </Link>
      </div>
      <div className="visible-xs">
        <Link
          className={`navbar-brand ${isAnchorPortal ? '' : 'navbar-brand-custom'}`}
          to={isAnchorPortal ? '/dashboard' : '/home'}
        >
          <img
            alt="Naked News: The Program With Nothing To Hide"
            className={`img-responsive ${isAnchorPortal ? 'anchor-portal-logo' : ''}`}
            src={logo}
          />
        </Link>
      </div>
    </div>
  );
};

HeaderLogoAndDropDown.propTypes = {
  activeCampaign: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  toggleMobileHeader: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  isAnchorPortal: PropTypes.bool,
  userPremiumExpired: PropTypes.bool,
};

HeaderLogoAndDropDown.defaultProps = {
  isAnchorPortal: false,
  userPremiumExpired: false,
};

export default HeaderLogoAndDropDown;
